let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ceBZg")).then(() => parcelRequire('2VxMN'));